// Small repeated visual components used across pages.
import { Wheat } from "lucide-react";

export function Overline({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-gomill-leaf ${className}`}>
      <Wheat className="w-3.5 h-3.5" /> {children}
    </span>
  );
}

export function Section({ children, className = "", id }) {
  return (
    <section id={id} className={`py-16 md:py-24 px-6 md:px-12 ${className}`}>
      <div className="max-w-[1400px] mx-auto">{children}</div>
    </section>
  );
}

export function Pill({ children, tone = "leaf" }) {
  const tones = {
    leaf: "bg-gomill-leaf/10 text-gomill-leaf",
    mustard: "bg-gomill-mustard/20 text-gomill-green",
    cream: "bg-gomill-cream text-gomill-green",
  };
  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider ${tones[tone]}`}>
      {children}
    </span>
  );
}

export function StatTile({ value, label }) {
  return (
    <div className="text-center md:text-left">
      <div className="font-serif text-4xl md:text-5xl text-gomill-green">{value}</div>
      <div className="text-xs uppercase tracking-[0.2em] text-gomill-muted mt-2">{label}</div>
    </div>
  );
}
